// extracted by mini-css-extract-plugin
module.exports = {"link":"_2XPjR","container":"_1H56q","contentPreview":"_2rwvh","image":"_3i59n","contentBlock":"_3NMFt","title":"_19AA9","numbersSeparator":"_1oXB0","categoryBadgeWrapper":"_1L15C"};